export const REFERRAL_TRACKING = {
  clickReferralCallbackRequest: 'Click Referral Callback Request',
  clickReferralSharePlatforms: 'Click Referral Share on Other Platforms',
  clickKnowMoreInviteBtn: 'Click Know More Invite Button',
  viewPostTARatingReferralModal: 'View Post TA Rating Referral Modal',
  viewReferralNudgeHappyFlowModal: 'View Referral Nudge Happy Flow Modal',
  clickInviteAndEarn: 'Invite & Earn',
  clickShareProofFormLink: 'Click Share Proof Form Link',
  clickKnowMoreButton: 'Click Know More',
  clickSstBannerEventLink: 'Register for launch event',
  clickSstBannerCloseButton: 'Close button',
  clickSstBannerKnowMore: 'Know more for sst',
  clickSstBannerReferButton: 'Refer button',
  viewSstNewBanner: 'View New SST FOMO Banner',
  viewRewardsCalculatorBanner: 'View Rewards Calculator Banner',
  clickCalculatorButton: 'Click Calculator Button',
  viewReferralProgramBanner: 'View Referral Program Banner',
  viewReferralNPSBanner: 'View Referral NPS Banner',
  viewReferralGoodiesBanner: 'View Referral Goodies Banner',
  viewReferralDiwaliBanner: 'View Referral Diwali Banner',
  clickTermsAndConditions: 'Click Terms & Conditions',
  clickCheckExtraReward: 'Click Check Extra Reward',
  clickRequestCallback: 'Click Request Callback',
  clickTryRewardsCalculator: 'Click Try Rewards Calculator',
  clickLinkedInShareButton: 'Click Share On LinkedIn',
  clickWhatsappShareButton: 'Click Share On Whatsapp',
  clickTwitterShareButton: 'Click Share On Twitter',
  clickDownloadImageButton: 'Click Download button image',
  clickMentorRevisitedTouchpoint: 'Click Mentor Revisited 2023 Touchpoint',
  clickNotNowButton: 'Click Not Now Button',
  clickedSocialShareButton: 'Click Social Share Button',
  clickExploreRewardsCalc: 'Click Explore Rewards Calc',
  clickUgRollingBannerKnowMore: 'Ug Rolling Banner Button Click',
  viewCelebratoryModal: 'View celebratory modal',
  clickUgRollingBannerExploreUg: 'Ug Rolling Banner Explore UG',
  clickUgRollingBannerCheckItOut: 'Ug Rolling Banner Check It Out',
  clickUgRollingBannerViewProject: 'Ug Rolling Banner View Project',
  viewCouponWidget: 'View coupon widget',
  clickCouponWidgetApply: 'Click Coupon Widget Apply',
  clickCouponModalApply: 'Click coupon modal Apply',
  viewCouponApplied: 'View Coupon Applied successfully',
  viewDronaRcbStrip: 'View Drona Rcb Strip',
};
